import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { HowItWorks } from '../components/HowItWorks';
import { ValueProposition } from '../components/ValueProposition';
import { UseCases } from '../components/UseCases';
import { ProductDeepDive } from '../components/ProductDeepDive';
import { TrustSecurity } from '../components/TrustSecurity';
import { Pricing } from '../components/Pricing';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-552">
      <Navbar data-id="element-553" />
      <main data-id="element-554">
        <HeroSection data-id="element-555" />
        <ProblemSection data-id="element-556" />
        <HowItWorks data-id="element-557" />
        <ValueProposition data-id="element-558" />
        <UseCases data-id="element-559" />
        <ProductDeepDive data-id="element-560" />
        <Pricing data-id="element-561" />
        <TrustSecurity data-id="element-562" />
        <FinalCTA data-id="element-563" />
      </main>
      <Footer data-id="element-564" />
    </div>;
}